import React from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";

const AutomaticReportPopup = ({ open, onCancel }) => {
  return (
    <div>
      <DailogBox open={open} onCancel={onCancel} width={700}>
        <div className="flex items-center  gap-2 text-xl  font-bold">
          <TextStyles color="gradient">Automatic Report</TextStyles>
        </div>
      </DailogBox>
    </div>
  );
};

export default AutomaticReportPopup;
